<template>
  <div>
    <b-row>
      <b-col class="text-center"><h4>Service Request</h4></b-col>
    </b-row>
    <b-row>
      <b-col class="text-center"
        >Use this form to send a service request to Angel Guard for
        assistance</b-col
      >
    </b-row>
    <b-row>
      <b-col class="text-center">Please complete the below details</b-col>
    </b-row>
    <hr />

    <b-row
      ><b-col cols="1"></b-col
      ><b-col cols="3" class="text-left">Raised By:</b-col
      ><b-col cols="7" class="text-left"> {{ this.username }}</b-col
      ><b-col cols="1"></b-col
    ></b-row>
    <br />
    <b-row
      ><b-col cols="1"></b-col><b-col cols="3" class="text-left">Email:</b-col
      ><b-col cols="7" class="text-left"
        ><b-form-input
          type="email"
          placeholder="Contact Email"
          v-model="ServiceEmail"/></b-col
      ><b-col cols="1"></b-col
    ></b-row>
    <br />
    <b-row
      ><b-col cols="1"></b-col><b-col cols="3" class="text-left">Tel:</b-col
      ><b-col cols="7" class="text-left"
        ><b-form-input
          type="tel"
          placeholder="Contact Tel"
          v-model="ServiceTel"/></b-col
      ><b-col cols="1"></b-col
    ></b-row>
    <br />
    <b-row
      ><b-col cols="1"></b-col
      ><b-col cols="3" class="text-left">Location:</b-col
      ><b-col cols="7" class="text-left">{{ this.selectedlocation }}</b-col
      ><b-col cols="1"></b-col
    ></b-row>
    <br />
    <b-row
      ><b-col cols="1"></b-col
      ><b-col cols="3" class="text-left">Originates:</b-col
      ><b-col cols="7" class="text-left"> {{ this.$RaisedFrom }} </b-col
      ><b-col cols="1"></b-col
    ></b-row>
    <br />
    <b-row
      ><b-col cols="1"></b-col
      ><b-col cols="3" class="text-left">Origin ID:</b-col
      ><b-col cols="7" class="text-left"> {{ this.$RaisedFromID }}</b-col
      ><b-col cols="1"></b-col
    ></b-row>
    <br />
    <b-row
      ><b-col cols="1"></b-col
      ><b-col
        ><b-form-textarea
          size="sm"
          placeholder="Details"
          max-rows="5"
          rows="5"
          v-model="ServiceDesc"
        ></b-form-textarea></b-col
      ><b-col cols="1"></b-col
    ></b-row>
    <br />
    <b-row
      ><b-col class="text-right"
        ><b-button variant="outline-info" size="sm" v-on:click="submitService()"
          >Submit</b-button
        ></b-col
      ><b-col class="text-left"
        ><b-button variant="outline-info" size="sm" v-on:click="resetService()"
          >Cancel</b-button
        ></b-col
      ></b-row
    >

    <hr />
  </div>
</template>
<script>
import axios from "axios";

export default {
  computed: {},
  components: {},
  mounted() {},

  data() {
    return {
      selectedlocation: localStorage.getItem("CurrentLocation"),
      UserURN: this.$UserURN,
      username: localStorage.getItem("fullname"),
      ServiceEmail: "",
      ServiceTel: "",
      ServiceDesc: "",
      EmailVal: "",
    };
  },

  methods: {
    submitService() {
      if (
        this.ServiceEmail == "" ||
        this.ServiceTel == "" ||
        this.ServiceDesc == ""
      ) {
        alert("Please complete all fields before submitting");
      } else if (this.ServiceEmail != "") {
        this.emailIsValid(this.ServiceEmail);
        if (this.EmailVal === false) {
          alert("Email Address does not appear to be valid");
        } else {
          let EmailService = {
            ToEmail: "Support@seraphprotect.online",

            EmailText:
              "Service Request raised by user.\\n\\n" +
              this.username +
              "\\n" +
              this.ServiceEmail +
              " - " +
              this.ServiceTel +
              "\\n\\n" +
              "Raised from " +
              this.$RaisedFrom +
              " - " +
              this.$RaisedFromID +
              "\\n\\n" +
              "Description: " +
              this.ServiceDesc,

            EmailSubject: "New Service Request ",
          };

          let EmailPosturl =
            "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/emailgateway";

          let EmailPostHeaders = this.$apikeyPost;

          axios
            .post(EmailPosturl, EmailService, EmailPostHeaders)
            .then((response) => {
              response;
            })
            .catch((err) => {
              "Error: ===", err;
            });
          alert(
            "Your Service Request has been submitted, a staff member will be in touch."
          );
          this.resetService();
        }
      }
    },
    resetService() {
      (this.ServiceTel = ""),
        (this.ServiceEmail = ""),
        (this.ServiceDesc = ""),
        this.$emit("service-close");
    },
    emailIsValid(email) {
      this.EmailVal = /\S+@\S+\.\S+/.test(email);
    },
  },
  watch: {},
};
</script>
<style scoped></style>
